import React from 'react';
import cn from 'classnames';
import { useStoreState } from 'base/store';
import KlarnaSteps from '@base/common/payMent/Klarna/KlarnaSteps';
import styles from './index.module.less';
import Image from '@base/lib/ThemeImage';
import { Trans, useTrans } from 'base/utils/i18n';
import { isPhone } from 'base/utils/client';

type IProps = {
    showTitle?: boolean;
}

const countriesConfig = {
    DE: {
        title: 'web_payment_klarna_slogen_de',
        text: 'web_payment_klarna_policy_de',
        link: 'https://www.klarna.com/de/kauferschutzrichtlinie/',
        steps: [
            'web_payment_klarna_step1_de',
            'web_payment_klarna_step2_de',
            'web_payment_klarna_step3_de',
            'web_payment_klarna_step4_de',
        ]
    },
    CA: {
        title: 'web_payment_klarna_slogen_ca',
        text: 'web_payment_klarna_policy_ca',
        link: 'https://www.klarna.com/ca/kauferschutzrichtlinie/',
        steps: [
            'web_payment_klarna_step1_ca',
            'web_payment_klarna_step2_ca',
            'web_payment_klarna_step3_ca',
            'web_payment_klarna_step4_ca',
        ]
    },
    GB: {
        title: 'web_payment_klarna_slogen_gb',
        text: 'web_payment_klarna_policy_gb',
        link: 'https://www.klarna.com/gb/kauferschutzrichtlinie/',
        steps: [
            'web_payment_klarna_step1_gb',
            'web_payment_klarna_step2_gb',
            'web_payment_klarna_step3_gb',
            'web_payment_klarna_step4_gb',
        ]
    },
}

const KlarnaInfo: React.FC<IProps> = (props) => {
    const { showTitle = true } = props

    const { t } = useTrans();

    const { country } = useStoreState('rootStore');
    const config = countriesConfig[country];

    return (
        <div className={cn('text-center', styles['after-pay-info'])}>

            {showTitle && (
                <div className={styles['title-img']}>
                    <Image
                        src={'asset/width-396/picture/8071f8f92396c2aa5e8dad35a1e10ad5.png'}
                        width={99}
                        height={48}
                        fixed
                        background={false}
                    />
                </div>
            )}

            {!!config && (
                <>
                    <div className={styles['sub-title']}>
                        <Trans
                            i18nKey={config.title}
                            components={{ br: isPhone ? <br/> : <></> }}
                        />
                    </div>

                    <KlarnaSteps steps={config.steps}/>

                    <div className={styles.msg}
                         dangerouslySetInnerHTML={{ __html: t(config.text) }}
                    />
                </>
            )}
        </div>
    );
};

export default KlarnaInfo